const CommonUrl = '/static/images/'

export const Image = {
  Logo: 'logocopy.png',
  LoginBg: 'bg.png',
  HomeBanner: 'home_banner.png',
  InfoBanner: 'info_banner.png',
  TabBottom: 'tab_bottom.png',
  Family1: 'family/1.png',
  Family2: 'family/2.png',
  Family3: 'family/3.png',
  Family4: 'family/4.png',
  Family5: 'family/5.png',
  Family6: 'family/6.png',
  Family7: 'family/7.png',
  Scane: 'scane.png',
  Input: 'input.png',
  IconSetup: 'icon/setup.png',
  IconRight: 'icon/right.png',
  IconCup: 'icon/cup.png',
  IconGroup: 'icon/group.png',
  IconModel: 'icon/model.png',
  IconService: 'icon/service.png',
  IconFeedback: 'icon/feedback.png',
  IconStar: 'icon/star.png',
  IconTool: 'icon/tool.png',
  IconDrop: 'icon/drop.png',
  IconMenu: 'icon/menu.png',
  IconDiyiming1: 'icon/diyiming1.png',
  IconDiyiming2: 'icon/diyiming2.png',
  IconDiyiming3: 'icon/diyiming3.png',
  IconEdit: 'icon/edit.png'

}

const Size = {
  '100x100': 'w=640&height=500'
}

export const SetImage = (imgList = [], { bundle = false, bundleName = 'Images' } = {}) => {
  let _r = {}
  if (bundle) {
    _r[bundleName] = () => {
      let _I = {}
      imgList.map(name => {
        const cutName = name.split('_')
        const imgSize = cutName[1] ? Size[cutName[1]] || '' : ''
        const imgUrl = Image[cutName[0]] || ''
        _I[name] = `${CommonUrl}${imgUrl}${imgSize ? '?' : ''}${imgSize}`
      })
      return _I
    }
  } else {
    imgList.map(name => {
      const cutName = name.split('_')
      const imgSize = cutName[1] ? Size[cutName[1]] || '' : ''
      const imgUrl = Image[cutName[0]] || ''
      _r[name] = () => {
        return `${CommonUrl}${imgUrl}${imgSize ? '?' : ''}${imgSize}`
      }
    })
  }
  return _r
}

export default SetImage
